export class SessionStorageService {
	private static readonly _shopOverrideKey = 'shopOverride';

	public static getShopOverride(): string | null {
		return this._get(this._shopOverrideKey);
	}

	public static setShopOverride(value: string): void {
		return this._set(this._shopOverrideKey, value);
	}

	private static _get(key: string): string | null {
		return window.sessionStorage.getItem(key);
	}

	private static _set(key: string, value: string): void {
		window.sessionStorage.setItem(key, value);
	}
}
